'use strict';

var React = require('react');
var PureRenderMixin = require('react').addons.PureRenderMixin;

var ReactForms = require('react-forms');

var Layout = require('ofs/forms/layout/layout');
var Row = require('ofs/forms/layout/row');
var Column = require('ofs/forms/layout/column');
var Group = require('ofs/forms/layout/group');

var Element = ReactForms.Element;

var contactLayouts = {
  'email': require('../mappings/email').layout,
  'call': require('../mappings/telephone').layout
};

var buildLayout = function(contactPreference) {
  var topicLayout = require('../mappings/search').layout;
  var contactLayout = contactLayouts[contactPreference];

  return React.createClass({
    mixins: [PureRenderMixin],

    render: function() {
      var value = this.props.value;

      return (
        <Layout>
          {topicLayout(value)}
          <Group>
            <Row><Column size="full"><Element value={value.get('message')} /></Column></Row>
            <Row><Column size="full"><Element value={value.get('contact_preference')} /></Column></Row>
            {contactLayout(value)}
          </Group>
        </Layout>
      );
    }
  });
};


module.exports = buildLayout;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/contact/search/layout.jsx
 **/